import CollectiblesPage from './collectibles'

function Home() {
  return <CollectiblesPage />
}

export default Home
